export const NO_DATA = '—';
